import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export function useTheme() {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within ThemeProvider');
    }
    return context;
}

export function ThemeProvider({ children }) {
    const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'light');
    const [highContrast, setHighContrast] = useState(() => localStorage.getItem('highContrast') === 'true');

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
        document.documentElement.setAttribute('data-contrast', highContrast ? 'high' : 'normal');
        localStorage.setItem('theme', theme);
        localStorage.setItem('highContrast', highContrast);
    }, [theme, highContrast]);

    const toggleTheme = () => {
        setTheme(prev => prev === 'light' ? 'dark' : 'light');
    };

    const toggleContrast = () => {
        setHighContrast(prev => !prev);
    };

    const value = {
        theme,
        highContrast,
        toggleTheme,
        toggleContrast,
    };

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    );
}
